module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[74]317.554c82b.woff2";